import { adminApi } from './api';
import { toast } from 'sonner';

const MAX_SIZE = 5 * 1024 * 1024;
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];

// Validates and uploads one or more image files (drag-and-drop or file picker), mirroring
// the extension/size rules already enforced server-side in POST /admin/uploads/image.
// Returns only the files that uploaded successfully; invalid/failed files are toast-reported
// and skipped rather than aborting the whole batch.
export const uploadImages = async (files, folder) => {
  const uploaded = [];
  for (const file of Array.from(files)) {
    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error(`${file.name}: unsupported type — use PNG, JPG, WEBP, or GIF`);
      continue;
    }
    if (file.size > MAX_SIZE) {
      toast.error(`${file.name}: must be under 5MB`);
      continue;
    }
    try {
      const result = await adminApi.uploadImage(file, folder);
      uploaded.push({ path: result.path, name: file.name });
    } catch (err) {
      console.error('Error uploading image:', err);
      toast.error(err.response?.data?.detail || `Failed to upload ${file.name}`);
    }
  }
  return uploaded;
};
